import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html {
    font-size: ${(props) => props.theme.fontSize};
  }
  body {
    background-color: ${(props) => props.theme.backgroundColor};
    font-family: ${(props) => props.theme.fontFamily};
    font-weight: ${(props) => props.theme.fontWeight};
    color: ${(props) => props.theme.fontColor};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    hyphens: auto;
    hyphenate-limit-chars: 10 3 4;
    hyphenate-limit-lines: 2;
    hyphenate-limit-last: always;
    @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
      hyphens: none;
    }
  }
  address {
    font-style: normal;
  }
`;

export default GlobalStyle;
